import { IFormSchema, Layout } from "@entaconsulting/form";
import { addError } from "common/store/messagesSlice";
import { useCallback } from "react";
import { useStore } from "react-redux";
import { RootState } from "store";
import { saveFormDefinition } from "store/form/formDataSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  cancelSaveWithErrorsConfirmation,
  requireSaveWithErrorsConfirmation,
} from "../store/editorSlice";

const useSaveEditorContent = () => {
  const formDefinitionId = useAppSelector(
    (state) => state.formData.formDefinitionId
  );

  const dispatch = useAppDispatch();
  const store = useStore<RootState>();

  return useCallback(() => {
    let schema: IFormSchema;

    const {
      schemaJsonEdited,
      layoutJsonEdited,
      optionsJsonEdited,
      confirmSaveWithErrors,
    } = store.getState().developer.edit.editor;

    const {
      isErrorInLayoutEditor,
      isErrorInOptionsEditor,
      isErrorInSchemaEditor,
    } = store.getState().developer.edit.codeEditor;

    if (
      (isErrorInSchemaEditor ||
        isErrorInLayoutEditor ||
        isErrorInOptionsEditor) &&
      !confirmSaveWithErrors
    ) {
      dispatch(requireSaveWithErrorsConfirmation());
      return;
    }
    if (confirmSaveWithErrors) {
      dispatch(cancelSaveWithErrorsConfirmation());
    }

    try {
      schema = JSON.parse(schemaJsonEdited);
    } catch {
      dispatch(
        addError({ message: "JSON is invalid for 'schema'. Unable to save" })
      );
      return;
    }

    let layout: Layout;

    try {
      layout = JSON.parse(layoutJsonEdited);
    } catch {
      dispatch(
        addError({ message: "JSON is invalid for 'layout'. Unable to save" })
      );
      return;
    }

    let options: any; //missing IFormOptions exported

    try {
      options = JSON.parse(optionsJsonEdited);
    } catch {
      dispatch(
        addError({ message: "JSON is invalid for 'options'. Unable to save" })
      );
      return;
    }

    dispatch(
      saveFormDefinition({
        formDefinition: { schema, layout, options },
        formDefinitionId,
      })
    );
  }, [store, dispatch, formDefinitionId]);
};

export default useSaveEditorContent;
